import { useAppTheme } from "@hooks/useAppTheme";
import { Box } from "@memorang/ui";
import { View } from "react-native";
import { Text } from "react-native-paper";
import {
	PROETHICA_KNOWLEDGE_CHECK_TOTAL,
	getKnowledgeCheckCorrectCount,
} from "../helpers/proethica-progress-data";

type Props = {
	scorePercent: number;
	totalQuestions?: number;
};

const DOT_SIZE = 8;
const DOT_GAP = 3;

export const KnowledgeCheckProgress = ({
	scorePercent,
	totalQuestions = PROETHICA_KNOWLEDGE_CHECK_TOTAL,
}: Props) => {
	const theme = useAppTheme();
	const correctCount = getKnowledgeCheckCorrectCount(
		scorePercent,
		totalQuestions,
	);

	return (
		<Box flexDirection="row" alignItems="center" style={{ gap: 8 }}>
			<Text
				variant="bodySmall"
				style={{ color: theme.colors.onSurface, fontSize: 11 }}
			>
				Knowledge check
			</Text>
			<Box flexDirection="row" style={{ gap: DOT_GAP }}>
				{([1, 2, 3, 4, 5] as const).slice(0, totalQuestions).map((slot) => (
					<View
						key={slot}
						style={{
							width: DOT_SIZE,
							height: DOT_SIZE,
							borderRadius: DOT_SIZE / 2,
							backgroundColor:
								slot <= correctCount
									? theme.colors.progress.high
									: theme.colors.progress.none,
						}}
					/>
				))}
			</Box>
			<Text
				variant="labelMedium"
				style={{
					color: theme.colors.onSurface,
					fontWeight: "600",
					fontSize: 12,
				}}
			>
				{correctCount}/{totalQuestions}
			</Text>
		</Box>
	);
};
